import React from 'react';
import { Input, Textarea } from '@roger/ui-components';
import { Question } from '../types';
import { FieldTemplatePicker } from '../FieldTemplatePicker';

interface TextQuestionProps {
  question: Question;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const TextQuestion: React.FC<TextQuestionProps> = ({
  question,
  value,
  onChange,
  disabled = false,
}) => {
  // Determine if this should be a textarea based on question content
  const shouldUseTextarea =
    question.question.toLowerCase().includes('describe') ||
    question.question.toLowerCase().includes('explain') ||
    question.question.toLowerCase().includes('details') ||
    question.question.toLowerCase().includes('comments');

  return (
    <div className='space-y-2'>
      {/* The picker sits with the label rather than above the control so a
          templated field reads as one unit. It renders nothing unless the
          agency has authored a template for this question. */}
      <div className='flex items-start justify-between gap-2'>
        <label className='text-sm font-semibold text-foreground block'>
          {question.question || question.description}
        </label>
        <FieldTemplatePicker
          qid={question.qid}
          currentValue={value || ''}
          onInsert={onChange}
          disabled={disabled}
        />
      </div>

      {shouldUseTextarea ? (
        <Textarea
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          className='w-full min-h-[72px]'
          textareaSize='default'
          placeholder='Enter response...'
        />
      ) : (
        <Input
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          placeholder='Enter response...'
          inputSize='default'
          className='w-full'
        />
      )}
    </div>
  );
};
